export const pie = {
  hole: 0.5,
  textfont: {
    color: '#fff'
  }
}



// WEBPACK FOOTER //
// ./src/types/pie.js